import type { StoreDetailsTabOption } from '../../../types/features/storeDetails/page';

export const getStoreDetailsTabs = (hasManualEntryOptions: boolean): StoreDetailsTabOption[] => [
    { key: 'overview', label: 'Overview' },
    { key: 'feature_flags', label: 'Feature Flags' },
    { key: 'audits', label: 'Audits' },
    { key: 'users', label: 'Users' },
    ...(hasManualEntryOptions ? [{ key: 'manual_entries' as const, label: 'POS Entries' }] : []),
    { key: 'store_locations', label: 'Inventory Locations' },
    { key: 'onboarding', label: 'Onboarding' },
    { key: 'case_simulator', label: 'Pack Simulators' },
    { key: 'sales_receipts', label: 'Sales Receipts' },
    { key: 'email_pipeline', label: 'Pipeline Status' },
    { key: 'notifications', label: 'Notifications' },
    { key: 'lotto_reco_console', label: 'Watchdog' },
];
